// consts
import { CALENDAR_TYPE } from 'app/config/calendar_type.js';
import { FREQUENCY } from 'app/config/frequency_type.js';

function _convertToMinutesFrequency({ calendarType, frequencyAmount, frequencyTypeId }) {
  //
  const { EVERY, TIMES_PER, PER_SHIFT } = CALENDAR_TYPE;
  const { WEEK_ID, BIWEEK_ID, MONTH_ID, DAY_ID, MINUTE_ID, HOUR_ID } = FREQUENCY;

  if (!calendarType || !frequencyAmount || !frequencyTypeId) {
    return null;
  }

  if (calendarType === EVERY) {
    if (frequencyTypeId === HOUR_ID) {
      return frequencyAmount * 60;
    }
    if (frequencyTypeId === MINUTE_ID) {
      return frequencyAmount * 1;
    }
    if (frequencyTypeId === DAY_ID) {
      return frequencyAmount * 24 * 60;
    }
    if (frequencyTypeId === WEEK_ID) {
      return frequencyAmount * 7 * 24 * 60;
    }
    if (frequencyTypeId === BIWEEK_ID) {
      return frequencyAmount * 14 * 24 * 60;
    }
    if (frequencyTypeId === MONTH_ID) {
      return frequencyAmount * 30 * 24 * 60;
    }
  }

  if (calendarType === TIMES_PER) {
    // TODO desenvolver
    return null;
  }

  if (calendarType === PER_SHIFT) {
    return null;
  }

  return null;
}

export default _convertToMinutesFrequency;
